import cx from "classnames";

export const getCssValueAndUnits = cssText => {
  const cssString = String(cssText);
  const value = Number((cssString.match(/^([0-9.\-]+)/) || [0]).pop());
  const units = String((cssString.match(/([a-z%]*)$/i) || [""]).pop());

  return [value, units];
};

const getButtonKind = kind => {
  if (!kind) kind = "";

  // strip outdated `-narrow`
  const [value] = kind.split("-");

  return value || "default";
};

export const getButtonClasses = (props, styles) => {
  const {
    blockName,
    children,
    disabled,
    isTwoLine,
    autoHeight,
    focused,
    hovered,
    pressed,
    className: userClassName
  } = props;
  const kind = getButtonKind(props.kind);
  const className = createClassNameCombinator(blockName, userClassName, styles);

  return cx(className(), {
    [className(`--${kind}`)]: kind,
    [className("--empty")]: !children,
    [className("--disabled")]: disabled === true,
    [className("--two-line")]: isTwoLine,
    [className("--auto-height")]: autoHeight,
    [className("--active")]: focused,
    [className("--hover")]: hovered && !focused,
    [className("--hover-active")]: hovered && focused,
    [className("--press")]: pressed
  });
};

export const createClassNameCombinator = (
  nextUIBaseClass = "nx-element",
  userBaseClass = "",
  classes
) => {
  return (classModifier = "") => {
    const styles = str => (classes ? classes[str] : str);
    const cssClass = `${nextUIBaseClass}${classModifier}`;
    const userCss = cx(userBaseClass).split(" ");

    return cx(styles(cssClass) || cssClass, {
      [userCss
        .filter(cssSelector => cssSelector)
        .map(cssClass => `${cssClass}${classModifier}`)
        .join(" ")]: userBaseClass
    });
  };
};

export const combineCssModules = (module1, module2) => {
  if (module2) {
    const combinedCssModule = { ...module1 };
    Object.entries(module2 || {}).forEach(([selector, cssClass]) => {
      if (combinedCssModule[selector]) {
        combinedCssModule[selector] += ` ${cssClass}`;
      } else {
        combinedCssModule[selector] = cssClass;
      }
    });

    return combinedCssModule;
  }

  return module1;
};
